<script lang="ts" setup>
import { computed } from "vue"
import brandLogoMaskUrl from '@/assets/layout/brand-logo.svg'
import logoIcon from '@/assets/layout/logo1.png'
import { useTheme } from "@/hooks/useTheme"

const props = defineProps({
  collapse: {
    type: Boolean,
    default: true,
  },
})

const { activeThemeProfile } = useTheme()
const brandLogoColor = computed(() => activeThemeProfile.value === "default"
  ? "#5D9CF9"
  : "var(--el-color-primary)")
</script>

<template>
  <div class="sidebar-logo-container" :class="{ collapse: props.collapse }">
    <transition name="sidebar-logo-fade">
      <router-link v-if="props.collapse" key="collapse" to="/">
        <img :src="logoIcon" class="sidebar-logo" alt="茶坊村" />
      </router-link>
      <router-link v-else key="expand" to="/">
        <span
          class="sidebar-logo-text"
          role="img"
          aria-label="茶坊村"
          :style="{
            '--brand-logo-mask': `url(${brandLogoMaskUrl})`,
            '--brand-logo-color': brandLogoColor,
          }"
        />
      </router-link>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: var(--v3-header-height);
  overflow: hidden;
  line-height: var(--v3-header-height);
  text-align: center;
  background-color: transparent;

  .sidebar-logo {
    display: none;
  }

  .sidebar-logo-text {
    display: inline-block;
    width: 102px;
    height: 38px;
    margin-left: 24px;
    vertical-align: middle;
    background-color: var(--brand-logo-color);
    mask: var(--brand-logo-mask) center / contain no-repeat;
  }
}

.collapse {
  .sidebar-logo {
    display: inline-block;
    width: 32px;
    height: 32px;
    vertical-align: middle;
  }

  .sidebar-logo-text {
    display: none;
  }
}
</style>
